<!-- TODO(TIF-21 Phase 1): Remove MockVideoPanelComponent -->
<div class="mock-video-panel">
  <div class="mock-video-panel__header">
    <mat-icon>videocam</mat-icon>
    <span>Video MMS Mock</span>
  </div>

  <div class="mock-video-panel__section">
    <span class="mock-video-panel__label">Terminal states</span>
    <div class="mock-video-panel__buttons">
      @for (item of terminalStates; track item.state) {
        <button mat-stroked-button (click)="triggerScenario(item.state)">{{ item.label }}</button>
      }
    </div>
  </div>

  <div class="mock-video-panel__section">
    <span class="mock-video-panel__label">Stuck states</span>
    <div class="mock-video-panel__buttons">
      @for (item of stuckStates; track item.state) {
        <button mat-stroked-button (click)="triggerScenario(item.state)">{{ item.label }}</button>
      }
    </div>
  </div>
</div>
